// extracted by mini-css-extract-plugin
module.exports = {"disabled":"ButtonSecondary_disabled__kMkBj","inverse":"ButtonSecondary_inverse__Iashs","default":"ButtonSecondary_default__hUjw8","fullWidth":"ButtonSecondary_fullWidth__FgtT1"};